import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModal, SuiModalService, ComponentModalConfig, ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { CompanyService } from "../../services";

// import { YearRecordModal } from '../year-record-modal/year-record-modal.component';
interface IEditProfitRecordModalContext {
	data: any;
	title?: string;
	isEdit?:boolean;
}
@Component({
	selector: 'app-edit-profit-record-modal',
	templateUrl: './edit-profit-record-modal.component.html',
	styleUrls: [ './edit-profit-record-modal.component.scss' ]
})
export class EditProfitRecordModalComponent implements OnInit, OnDestroy {

	searchable: boolean = true;
	public mode: DatepickerMode = 'year';
	public maxDate = new Date();
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt: boolean;
	success: any;
	error: any;
	pending: boolean;

	companyTccRecordForm: FormGroup;
	companyTccRecord:any;
	constructor(
		private companySvc:CompanyService,
		private modalService: SuiModalService,
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		public modal: SuiModal<IEditProfitRecordModalContext, void, void>
	) {
		this.companyTccRecordForm = fb.group({
			year: [ '' ],
			totalProfit: [ '' ],
			assessableProfit: [ '' ],
			turnOver: [ '' ],
			taxPaid: [ '' ],

		});
		if(modal.context.isEdit){
			this.companyTccRecord=modal.context.data
			this.companyTccRecordForm.patchValue(modal.context.data)
		}
	}
	isFieldValid(field: string) {
		return (
			(!this.companyTccRecordForm.get(field).valid && this.companyTccRecordForm.get(field).touched) ||
			(this.companyTccRecordForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	displayFormCss(field: string) {
		return {
			loading: field
		};
	}


	submit(){
		this.modal.context.isEdit == true?this.update():this.save()
	}

	save() {
		this.formSubmitAttempt = false;
		if (this.companyTccRecordForm.valid) {
			this.pending = true;
			this.companySvc.addCompanyEquipment({ body: this.companyTccRecordForm.value }).subscribe(
				(res) => {
					this.pending = false;
					this.success = 'Company Tcc Record added successfully';
					setTimeout(() => {
						this.modal.approve(null);
					}, 2000);
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
		} else {
			this.formSubmitAttempt = true;
		}
	}

	update() {
		this.formSubmitAttempt = false;
		if (this.companyTccRecordForm.valid) {
			this.pending = true;
			this.companySvc
				.updateCompanyEquipment({
					id: this.companyTccRecord.organizationEquipmentId,
					body: { ...this.companyTccRecord, ...this.companyTccRecordForm.value }
				})
				.subscribe(
					(res) => {
						this.pending = false;
						this.success = 'Company Tcc record updated successfully';
						setTimeout(() => {
							this.modal.approve(null);
						}, 2000);
					},
					(error) => {
						this.pending = false;
						this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
					}
				);
		} else {
			this.formSubmitAttempt = true;
		}
	}


	nullify() {
		this.success = null;
		this.error = null;
	}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}

	yearRecord() {
		// this.modalService
		// 	.open(new YearRecordModal('Year Records', 'Are you sure you want to delete this Lot plan?', ModalSize.Tiny))
		// 	.onApprove(() => {})
		// 	.onDeny(() => {});
	}
}

export class EditProfitRecordModal extends ComponentModalConfig<IEditProfitRecordModalContext, void, void> {
	constructor(title: string, data: string, size: ModalSize = ModalSize.Small) {
		super(EditProfitRecordModalComponent, { title, data });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
